import { render } from "./Campaigns.vue?vue&type=template&id=77be680e&scoped=true"
import script from "./Campaigns.vue?vue&type=script&lang=js"
export * from "./Campaigns.vue?vue&type=script&lang=js"

import "./Campaigns.vue?vue&type=style&index=0&id=77be680e&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77be680e"]])

export default __exports__